// extracted by mini-css-extract-plugin
module.exports = {"topTip":"Tip_topTip__vPlP_"};